// import React from "react";
// import { Controller } from "react-hook-form";
// import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from "@mui/x-date-pickers";
// import { MobileTimePicker } from "@mui/x-date-pickers";
// import 'dayjs/locale/en-in';
// import { useState } from "react";
// import { TextField } from "@mui/material";


// const TimePick = ({
//     label,
//     variant,
//     disabled,
//     defaultValue,
//     placeholder,
//     InputProps,
//     size,
//     fullWidth,
//     color,
//     helperText,
//     children,
//     select,
//     width,
//     multiline,
//     control,
//     name,
//     height,
// }) => {
//     const [reqTime, setreqTime] = useState(new Date());

//     return (

//         <Controller
//             name={name}
//             control={control}
//             render={
//                 ({ field: { onChange, ...restField } }) => (
//                     <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-in">
//                         {/* <DatePicker slotProps={{ textField: { size: 'small' } }}
//                             label={label}
//                             onChange={(event) => { onChange(event); setreqTime(event); }}
//                             sx={{ width: width ? width : "16.625vw" }}
//                             renderInput={(params) =>
//                                 <TextField size="small" {...params}
//                                 />}
//                         /> */}
//                         <DemoContainer
//                             components={[
//                                 'MobileTimePicker',
//                             ]}
//                         >
//                             <DemoItem>
//                                 <MobileTimePicker 
//                                 slotProps={{textField: {size: 'small'}}}
//                                 label={label}
//                                 onChange={(event) => {onChange(event); setreqTime(event)}}
//                                 sx={{width: width ? width : '18.25vw'}}
//                                 renderInput={(params) => 
//                                     <TextField size="small" {...params} />
//                                 }                                
//                                 />
//                             </DemoItem>

//                         </DemoContainer>
//                     </LocalizationProvider>
//                 )}
//         />
//     );
// };

// export default TimePick;

import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from "@mui/x-date-pickers";
import 'dayjs/locale/en-in';
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const TimePick = ({
    label,
    width,
    control,
    name,
    defaultValue, // <-- defaultValue from props
}) => {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || dayjs()} // <-- set defaultValue here
            render={({ field: { onChange, value } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-in">
                    <DemoContainer components={['MobileTimePicker']}>
                        <DemoItem>
                            <MobileTimePicker
                                label={label}
                                value={value || dayjs()} // <-- controlled value
                                onChange={(val) => onChange(val)}
                                slotProps={{ textField: { size: 'small' } }}
                                sx={{ width: width ? width : '18.25vw' }}
                            />
                        </DemoItem>
                    </DemoContainer>
                </LocalizationProvider>
            )}
        />
    );
};

export default TimePick;
